import { render, staticRenderFns } from "./DiagramPartCard.vue?vue&type=template&id=e70514ca"
import script from "./DiagramPartCard.ts?vue&type=script&lang=ts&external"
export * from "./DiagramPartCard.ts?vue&type=script&lang=ts&external"
import style0 from "./DiagramPartCard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports